"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.categoryValidationService = void 0;
var CategoryValidationService_1 = require("./implementation/CategoryValidationService");
exports.categoryValidationService = new CategoryValidationService_1.CategoryValidationService();
//# sourceMappingURL=index.js.map